const DataFactory = require('./lib/DataFactory.js')

module.exports = DataFactory
